module.exports = __webpack_public_path__ + "static/img/v74.7e8c492.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v74.png
// module id = 7DJh
// module chunks = 1